module.exports = __webpack_public_path__ + "c6318df9a2a0060f8ba586b25f31d798.png";